import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <div className='footer'>
        <div className="social-media">
          <ul>
            <li><a href="https://github.com/NeryHub" ><img src={require('./galerie/icons8-github-48.png')} alt="Github"/></a> </li>
            <li><a href="https://www.linkedin.com/in/nerias-andrade-1514bb143?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BjYXfC5N0R%2FS2Wyol1wXDtw%3D%3D" ><img src={require('./galerie/icons8-linkedin-48.png')} alt="LinkedIn"/></a> </li>
          </ul>
        </div>
      
        <div className="bottom-links">
          <ul>
            <li>Home</li>
            <li>::</li>
            <li>About Me</li>
            <li>::</li>
            <li>Contacts</li>
          </ul>
        </div>
        
        <div className="copy-rights">
          <p>Copyright © 2023 Nerias Andrade • Lisbon based Junior Web Developer</p>
        </div>
    </div>
  )
}
